<template>
  <div class="c-lo-dialog i-tab">
    <div class="c-content">
      <div class="content__left">
        <card-header>知识点详情</card-header>
        <point-list :data="data" v-model="knowledgeCode" />
      </div>
      <div class="content__right">
        <p class="content__header" style="padding-bottom: 24px">
          <span class="content__title">{{ videoHandout.tag_name }}</span>
          <i
            class="el-icon-close"
            style="z-index: 2"
            @click="$emit('update:visible', false)"
          ></i>
        </p>
        <div
          style="height: calc(100% - 49px); overflow: auto; position: relative"
        >
          <div ref="header" class="s-header"></div>
          <el-tabs v-model="activeName" class="i-tab--sm">
            <el-tab-pane
              :label="item.label"
              :name="item.name"
              v-for="item in tabList"
              :key="item.name"
            >
              <component
              :is="item.component"
              :data="getData(item.name)"
              :totalCount="totalCount"
              :type="scienceArr.includes(Number(subjectId))"
              :questionList="questionList"
              :searchForm="searchForm"
              :classId="classId"
              :subjectId="subjectId"
              :exerciseType="exerciseType"
               />
            </el-tab-pane>
          </el-tabs>
          <footer style="padding-top: 20px">
            <button
              :style="hasPre ? 'visibility:visible' : 'visibility:hidden'"
              @click="onPreClick"
            >
              上一个知识点
            </button>
            <button
              @click="onNextClick"
              :style="hasNext ? 'visibility:visible' : 'visibility:hidden'"
            >
              下一个知识点
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardHeader from '@/components/card-header.vue';
import {
  getCommonWeakTagCodeDetail, getCommonWeakTagDetail,
  getClassCommonWrongQuestionList, evaluateClassCommonWrongQuestionList,
} from '@/api/pt';
import PointList from '@/views/pt/lesson-prepare/components/point-list.vue';
import VideoHandout from '@/views/pt/lesson-prepare/components/video-handout.vue';
import QuestionResource from '@/views/pt/exercise-center/components/lodialog-question.vue';
import AnalyzeStatus from '@/views/pt/exercise-center/components/analyze-status.vue';

export default {
  components: { CardHeader, PointList, AnalyzeStatus },
  name: 'LoDialog',
  props: {
    code: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    subjectId: {
      type: [String, Number],
      default: '',
    },
    classList: {},
    searchForm: {},
    classId: {},
    time: {},
    radio: {},
    courseId: {},
    testId: {},
    category: {},
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      schoolId: userInfo.campusId,
      exerciseType: this.$route.path.includes('exercise-type'),
      activeName: 'analyzeStatus',
      totalCount: 0,
      knowledgeCode: this.code,
      changeTestId: this.testId,
      videoHandout: {},
      scienceArr: [2, 4, 5],
      questionList: [],
    };
  },
  computed: {
    currentIndex() {
      return this.data
        .findIndex((item) => item.tag_code === this.knowledgeCode);
    },
    hasPre() {
      return this.currentIndex > 0;
    },
    hasNext() {
      return this.currentIndex < this.data.length - 1;
    },
    hasHandout() {
      return this.videoHandout;
    },
    hasQuestion() {
      return this.questionList.length;
    },
    tabList() {
      return [{
        label: '掌握情况',
        name: 'analyzeStatus',
        component: AnalyzeStatus,
        visible: true,
      }, {
        label: '视频讲义',
        name: 'handout',
        component: VideoHandout,
        visible: this.hasHandout,
      }, {
        label: '相关错题',
        name: 'question',
        component: QuestionResource,
        visible: true,
      }].filter((item) => item.visible);
    },
  },
  watch: {
    knowledgeCode: {
      immediate: true,
      handler(v) {
        const SchoolClassId = this.classList.filter(
          (item) => item.id === this.classId,
        )[0].school_master_class_id;
        console.log(SchoolClassId);
        this.questionList = [];
        const params = {
          class_id: this.classId,
          school_master_class_id: SchoolClassId,
          subject_id: this.category.subjectId || 2,
          test_id: this.data.filter((item) => item.tag_code === v)[0].test_id,
          course_id: this.courseId,
          lesson_id: '',
          tag_codes: v,
          q_type: '',
          difficulty: '',
          start_time: this.radio !== '1' ? this.searchForm.startDate : '',
          end_time: this.radio !== '1' ? this.searchForm.endDate : '',
          grade_year: this.radio === '1' ? this.selectedYear : '',
          order: '',
          sort: '',
          page: 1,
          page_size: 100,
        };
        let code;
        if (this.exerciseType) {
          code = {
            school_id: this.schoolId,
            tag_code: v,
            class_id: this.classId,
            course_id: this.courseId,
            req_type: this.radio,
            time: this.time,
          };
        } else {
          code = {
            school_id: this.schoolId,
            tag_code: v,
            class_id: this.classId,
            test_id: this.data.filter((item) => item.tag_code === v)[0].test_id,
            req_type: this.radio,
            time: this.time,
          };
        }
        Promise.all([
          this.getCommonWeak(code),
          this.queryClassCommonWrongQuestionList(params),
        ]).then(() => {
          setTimeout(() => {
            this.$refs.header.scrollIntoView({
              behavior: 'smooth',
            });
          }, 20);
        });
      },
      deep: true,
    },
  },
  methods: {
    getCommonWeak(code) {
      if (this.exerciseType) {
        getCommonWeakTagCodeDetail(code).then((res) => {
          if (res.code === 200) {
            this.videoHandout = res.data;
          }
        });
      } else {
        getCommonWeakTagDetail(code).then((res) => {
          if (res.code === 200) {
            this.videoHandout = res.data;
          }
        });
      }
    },
    queryClassCommonWrongQuestionList(params) {
      console.log({ params });
      if (this.exerciseType) {
        getClassCommonWrongQuestionList(params).then((res) => {
          if (res.code === 200) {
            this.questionList = res.data.items || [];
            this.totalCount = res.data.total;
            this.questionList.forEach((item) => {
              this.$set(item, 'active', false);
            });
          } else {
            this.$message({
              type: 'warning',
              message: '请选择班级',
            });
          }
        });
      } else {
        evaluateClassCommonWrongQuestionList(params).then((res) => {
          if (res.code === 200) {
            this.questionList = res.data.items || [];
            this.totalCount = res.data.total;
            this.questionList.forEach((item) => {
              this.$set(item, 'active', false);
            });
          } else {
            this.$message({
              type: 'warning',
              message: '请选择班级',
            });
          }
        });
      }
    },
    onPreClick() {
      this.changeTestId = this.data[this.currentIndex - 1].test_id;
      this.knowledgeCode = this.data[this.currentIndex - 1].tag_code;
    },
    onNextClick() {
      this.changeTestId = this.data[this.currentIndex + 1].test_id;
      this.knowledgeCode = this.data[this.currentIndex + 1].tag_code;
    },
    getData(name) {
      const dataMap = {
        question: this.questionList,
        handout: this.videoHandout,
      };
      if (name === 'analyzeStatus') {
        return dataMap;
      }
      return dataMap[name];
    },
  },
};
</script>

<style lang="scss" scoped>
.c-lo-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .s-header {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    visibility: hidden;
  }
  .c-content {
    width: 50vw;
    height: 570px;
    max-width: 90%;
    max-height: 90%;
    background: #ffffff;
    border-radius: 4px;
    position: relative;
    display: flex;
  }
  .el-icon-close {
    position: absolute;
    top: 17px;
    right: 17px;
    color: rgba(126, 129, 133, 1);
    font-size: 30px;
  }
  .content__left {
    width: 220px;
    height: 100%;
    background: #ffffff;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    border-radius: 4px 0px 0px 4px;
    padding: 24px;
    box-sizing: border-box;
    display: none;
  }
  .content__right {
    flex: 1;
    box-sizing: border-box;
    padding: 28px 23px;
    overflow: hidden;
    position: relative;
    footer {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      margin-top: 20px;
    }
    button {
      color: rgba(25, 137, 250, 1);
      font-size: 14px;
    }
  }
  .content__title {
    width: 181px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 25px;
    position: relative;
    &::after {
      content: "";
      width: 100%;
      height: 13px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 7px;
      position: absolute;
      left: 0;
      bottom: 5px;
    }
  }
  .content__header {
    padding-left: 33px;
    background-image: url("~@/views/pt/images/ic_star.png");
    background-repeat: no-repeat;
    background-position: left top 5px;
    background-size: 24px auto;
    padding-left: 32px;
  }
}
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      // width: 100px !important;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/ {
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 54px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
.i-tab--sm {
  /deep/ {
    .el-tabs__item {
      font-size: 16px;
      // padding: 0 8px !important;
      margin: 0 !important;
      width: 80px !important;
    }
    .el-tabs__active-bar::after {
      display: none;
    }
  }
}
</style>
